import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * Videoaulas de curso, lado do aluno (spec r4/12).
 *
 * `useOpenLesson` e mutation, nao query: abrir a aula grava o "assistido" (R7) e a URL
 * do player nao deve ficar em cache — a aula que o admin bloquear amanha nao pode
 * continuar tocando por uma resposta guardada. Ao abrir, o curso e invalidado para a
 * aula que dependia desta ("depois de assistir") aparecer liberada.
 */

export const VIDEO_COURSES_KEY = ['video-courses'] as const

export function useVideoCourses() {
  return useQuery({
    queryKey: VIDEO_COURSES_KEY,
    queryFn: () => api.videoCourses.list(),
    staleTime: 1000 * 60,
  })
}

export function useVideoCourse(id: number | null) {
  return useQuery({
    queryKey: [...VIDEO_COURSES_KEY, id],
    queryFn: () => api.videoCourses.get(id as number),
    enabled: id !== null && Number.isFinite(id),
    staleTime: 1000 * 60,
  })
}

/** O curso de onboarding oferecido no fim do formulario (R6). */
export function useOnboardingVideoCourse() {
  return useQuery({
    queryKey: [...VIDEO_COURSES_KEY, 'onboarding'],
    queryFn: () => api.videoCourses.onboarding(),
    staleTime: 1000 * 60,
  })
}

export function useOpenLesson() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => api.videoCourses.openLesson(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VIDEO_COURSES_KEY })
    },
  })
}
